import React from 'react';
import ReactDOM from "react-dom";
import Invoice from './invoice';
import Login from './login';
import UserProfile from './userProfile';
import CustomerProfile from './customerProfile';

export default class Console extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
        };
    }

    clientsDataGet = () => {
        CustomerProfile.setCompanyID(0); //törlöm a history miatt.
        CustomerProfile.setCustomer('');
        CustomerProfile.setDate('');
        CustomerProfile.setDate2('');
        document.getElementById('console').style.display = 'none';
        new Invoice().clientsGet();
    };

    customerRecording = () => {
        CustomerProfile.setCompanyID(0);
        CustomerProfile.setCustomer('');
        document.getElementById('console').style.display = 'none';
        new Invoice().customerRecording();
    };

    itemRecording = () => {
        CustomerProfile.setCompanyID(0);
        CustomerProfile.setCustomer('');
        document.getElementById('console').style.display = 'none';
        new Invoice().itemRecording();
    }

    history = () => {
        document.getElementById('console').style.display = 'none';
        new Invoice().history();
    };

    exit = () => {
        UserProfile.setHashName('');
        UserProfile.setUserID(0);
        UserProfile.setUserVat(0);
        UserProfile.setCompanyID(0);
        ReactDOM.render(
            <Login name="Azonosítás szükséges" value="Belépés" />, document.getElementById("invoiceShow")
        );
    }

    render() {
        return (
            <div>
                <div>
                    <button className="push" onClick={() => this.clientsDataGet()}>
                        {"Tőrzs állomány"}
                    </button>
                </div>
                <div>
                    <button className="push" onClick={() => this.customerRecording()}>
                        {"Ügyfél rögzítése"}
                    </button>
                </div>
                <div>
                    <button className="push" onClick={() => this.itemRecording()}>
                        {"Tétel rögzítése"}
                    </button>
                </div>
                <div>
                    <button className="push" onClick={() => this.history()}>
                        {"Előzmények"}
                    </button>
                </div>
                <div>
                    <button className="push" onClick={() => this.exit()}>
                        {"Kilépés"}
                    </button>
                </div>
            </div>
        );
    }
}